import { IStorageVersion } from 'src/core/classes/models/IStorageVersion'
import VersionApi from 'src/core/classes/services/api/VersionApi'

class VersionStoreService {
  private versionStorage: IStorageVersion[] = []

  public init = async () => {
    const { items, error } = await VersionApi.getAPIVersions()
    this.versionStorage = items || []
    return { items, error }
  }

  public checkApiVersion = (key: string, version: number): boolean => {
    const currentVersionObject = this.versionStorage.find((el) => el.key === key)
    if (currentVersionObject) {
      return currentVersionObject.version !== version
    }
    return true
  }

  public updateApiVersion = async (key: string): Promise<number> => {
    const item = await VersionApi.updateVersionByAPI(key)
    this.versionStorage = this.versionStorage.map((el) => (el.key === item.key ? item : el))
    return item.version
  }

  public getApiVersionByKey = (key: string) => {
    return this.versionStorage.find((el) => el.key === key)
  }

  public getAllVersions = (): IStorageVersion[] => {
    return this.versionStorage.map((v) => ({ ...v }))
  }

  public deleteApiVersion = async (key: string): Promise<boolean> => {
    const result = await VersionApi.deleteVersionByAPI(key)
    if (result) {
      this.versionStorage = this.versionStorage.filter((v) => v.key !== key)
    }
    return result
  }
}

export default new VersionStoreService()
